var MAILTO_PROTOCOL = "mailto:";
/**
 * Enforces contents of links to match their href.
 * @param element HTMLAnchorElement or HTMLElement potentially container anchor elements
 */
export default function syncLinkHrefWithContent(element) {
    if (element.tagName === "A") {
        var anchorElement = element;
        var url = new URL(anchorElement.href);
        var prefix = url.protocol === MAILTO_PROTOCOL ? MAILTO_PROTOCOL : "";
        anchorElement.href = prefix + anchorElement.textContent;
        return;
    }
    var anchorElements = element.getElementsByTagName("a");
    for (var i = 0; i < anchorElements.length; i++) {
        syncLinkHrefWithContent(anchorElements[i]);
    }
}
//# sourceMappingURL=syncLinkHrefWithContent.js.map